import { render } from "./PaperIcon16.vue.js?vue&type=template&id=4bca5b5e!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./PaperIcon16.vue?vue&type=template&id=4bca5b5e"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__